const filestack = require('filestack-js');

const fileStackClient = filestack.init('AVsLFCmooSeCfsjDRz3Cbz');

module.exports = fileStackClient;
